import {
    getSearchResults as getSearchResultsEndeca,
    getSearchDetailResult as getSearchDetailResultEndeca,
    getBRSearchResults,
} from './Endeca/EndecaSearchApi';

export const getSearchResults = (params, regionZone, version, disableNewAutoSuggestion) =>
    getSearchResultsEndeca(params, regionZone, version, disableNewAutoSuggestion);

export const getSearchDetailResult = (searchTerm) => getSearchDetailResultEndeca(searchTerm);

export const getSearchResultsFromBR = (params, version) => getBRSearchResults(params, version);
